import { TFunction } from 'i18next';
import { FieldsItemType } from './types';

export const getFieldsConfig = ({ t }: { t: TFunction }) => [
  {
    id: 'managementRoles',
    type: FieldsItemType.Select,
    required: false,
    multiple: true,
    props: {
      name: 'managementRoles',
      placeholder: t('login-rules.form.modal.management-role-label'),
      fullWidth: true,
      label: t('login-rules.form.modal.management-role-label'),
    },
  },
  {
    id: 'companyTypes',
    type: FieldsItemType.Select,
    required: false,
    multiple: true,
    props: {
      name: 'companyTypes',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.company-type-label'),
    },
  },
  {
    id: 'companyNames',
    type: FieldsItemType.Input,
    multiple: true,
    props: {
      name: 'companyNames',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.company-contains-label'),
    },
  },
  {
    id: 'countries',
    type: FieldsItemType.Select,
    required: false,
    multiple: true,
    props: {
      name: 'countries',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.country-label'),
    },
  },
  {
    id: 'fieldOffices',
    type: FieldsItemType.Select,
    required: false,
    multiple: true,
    props: {
      name: 'fieldOffices',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.locale-label'),
    },
  },
  // {
  //   id: 'userGroups',
  //   type: FieldsItemType.Select,
  //   required: false,
  //   multiple: true,
  //   props: {
  //     name: 'userGroups',
  //     placeholder: t(''),
  //     fullWidth: true,
  //     label: t('login-rules.form.modal.user-group-label'),
  //   },
  // },
  {
    id: 'programs',
    type: FieldsItemType.Select,
    required: false,
    multiple: true,
    props: {
      name: 'programs',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.program-label'),
    },
  },
  {
    id: 'programLevels',
    type: FieldsItemType.Select,
    required: false,
    multiple: true,
    props: {
      name: 'programLevels',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.program-level-label'),
    },
  },
  {
    id: 'certificates',
    type: FieldsItemType.Select,
    multiple: true,
    props: {
      name: 'certificates',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.certificate-label'),
    },
  },
  {
    id: 'userDirectoryIds',
    type: FieldsItemType.Select,
    multiple: true,
    props: {
      name: 'userDirectoryIds',
      placeholder: t(''),
      fullWidth: true,
      label: t('login-rules.form.modal.user-directory-id-label'),
    },
  },
];
